import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';

@Component({
  selector: 'app-mapview',
  templateUrl: './mapview.component.html',
  styleUrls: ['./mapview.component.scss']
})
export class MapviewComponent implements OnInit {

  constructor(private data: DataService, private router:Router) { }

  lat = 51.678418;
  lng = 7.809007;
  public pname: string;
  
  center: google.maps.LatLngLiteral = {lat: this.lat, lng: this.lng};
  zoom = 18;
  markerPosition: google.maps.LatLngLiteral = {lat: this.lat, lng: this.lng};
  
  mapOptions: google.maps.MapOptions = {
    mapTypeId: 'hybrid'
  };
  
  markerOptions: google.maps.MarkerOptions = {
    draggable: false
  };
  
  ngOnInit(): void {
    this.pname = this.data.SelectedProperty.propertydetails.buildingname;
    
    var l =this.data.SelectedProperty.propertydetails.gpslocation;

    var ls = l.split(",")
    console.log(ls);
    
    var lats = ls[0].split(" ");
    var longs = ls[1].split(" ");
    var lat = lats[lats.length -1];
    var lng = longs[longs.length -1];
    console.log(lat)
    console.log(lng);

    this.lat = Number.parseFloat(lat);
    this.lng = Number.parseFloat(lng);
    
    this.center = {lat: this.lat, lng: this.lng};
    this.markerPosition = {lat: this.lat, lng: this.lng};
  }

}
